// FAMILY-EXT: feature 1+2 — звуковой сигнал при автоматическом возврате
// карточки из скрытого состояния (когда сервер истёк hidden_until).
// Реализован через Web Audio API — без аудиофайла, генерируем короткий
// двух-тон бип. Гарантия "однократно за сессию на карточку" через
// sessionStorage.

const PLAYED_KEY_PREFIX = 'family-return-sound-played:';

export function playReturnSound() {
  try {
    const AudioCtxCtor = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtxCtor) return;
    const ctx = new AudioCtxCtor();
    // Браузеры требуют пользовательский жест для AudioContext.resume().
    // Best-effort: если нет, тихо игнорируем.
    if (ctx.state === 'suspended') {
      ctx.resume().catch(() => {});
    }
    const now = ctx.currentTime;
    const playTone = (freq, start, dur) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.001, start);
      gain.gain.linearRampToValueAtTime(0.25, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, start + dur);
      osc.start(start);
      osc.stop(start + dur + 0.05);
    };
    // Бим-бам: два короткие ноты для узнаваемости.
    playTone(660, now, 0.18);
    playTone(880, now + 0.2, 0.25);
  } catch (e) {
    // ignore — звук не критичен
  }
}

// Проигрывает только если для этой пары (cardId, lastReturnedAt) ещё
// не играли в текущей вкладке. Защита от повторов при перерендере.
export function maybePlayReturnSoundFor(cardId, lastReturnedAt) {
  if (!cardId || !lastReturnedAt) return;
  try {
    const key = `${PLAYED_KEY_PREFIX}${cardId}:${lastReturnedAt}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
  } catch (e) {
    // sessionStorage недоступен (приватный режим?) — играем без защиты
  }
  playReturnSound();
}
